// action for sharebot enable or disable
export const ENABLE_SHAREBOT = 'ENABLE_SHAREBOT'
export const DISABLE_SHAREBOT = 'DISABLE_SHAREBOT'
export const ENABLE_ASSISTANCE = 'ENABLE_ASSISTANCE'
export const DISABLE_ASSISTANCE = 'DISABLE_ASSISTANCE'

export const enableShareBot = () => ({
    type: ENABLE_SHAREBOT
})

export const disableShareBot = () => ({
    type: DISABLE_SHAREBOT
})
export const enableAssistance = () => ({
    type: ENABLE_ASSISTANCE
})
export const disableAssistance = () => ({
    type: DISABLE_ASSISTANCE
})

